import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

import './lib/polyfills';
import Viewport from './core/Viewport';
import Components from './core/Components';
import AddToCartHandler from './lib/AddToCartHandler';
import ViewportHeight from './lib/ViewportHeight';
import lazySizes from './lib/lazysizes';
import BlurHashed from './lib/BlurHashed';
import ProductListingsTracker from "./lib/ProductListingsTracker";

gsap.defaults({ overwrite: 'auto' });
gsap.registerPlugin(ScrollToPlugin);

const init = () => {
    Viewport.init();
    Viewport.initTabbing();
    ViewportHeight.init();
    Components.init();
    ProductListingsTracker.init();
    AddToCartHandler.init();
    BlurHashed.init();
    lazySizes.init();
};

require('doc-ready')(init);
